import { render, staticRenderFns } from "./hotelImageList.vue?vue&type=template&id=c8d89d50&scoped=true"
import script from "./hotelImageList.vue?vue&type=script&lang=js"
export * from "./hotelImageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d89d50",
  null
  
)

export default component.exports